import { createChatNoticeGate, openChatId } from './utils/chatNoticeGate';
import { reconcileEvents } from './utils/reconcileEvents';
import { listenMediaQuery } from './utils/mediaQueryListener';
import { ACCESS_UPDATE_KEY } from './utils/accessUpdates';
import { createContext, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { usePersonalChatRealtime } from "./hooks/usePersonalChatRealtime";
import { API_URL, APIGetAdditionalService, APIGetListDeal, APIGetDeal, APIGetEmployee, APIGetEvents, APIGetPaymentEvent, APIGetUnreadCounts, APIMarkMessagesAsRead, APIVerifyToken, createNotificationWebSocketConnection, APIGetCitys, APIGetEmployeesList, APIGetEmployeesAll, APIGetPrograms, APIRegisterPushSubscription, APIGetOverdueEvents, APIGetActiveProcesses, APIGetSupplementStatus, APIGetCompletionStatus, APICheckPushByToken,
    APIGetManagerApplications,
    APIGetApplicationDetail,
    APIGetUnassignedApplicationsCount,
    APIGetNotifications, APIMarkNotificationRead, APIMarkAllNotificationsRead,
    APIGetEmployeeChoices,
    APIGetPendingRegistrations,
    APIGetNewsFeed,
    APINewsStories, APIMyPermissions
} from "./api";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router";
// import { useNotifications } from "./hooks/useNotifications";
import { useSound } from "./hooks/useSound";
import LockPage from "./pages/LockPage";
import { Box, CircularProgress, Stack, Typography } from "@mui/joy";
import ModalTechSupport from "./components/Modals/ModalTechSupport";
import { urlBase64ToUint8Array } from "./utils/pushUtils";
import axios from "axios";
import { getHomePathForRole } from './roles';
import { getAvailableCabinets, resolveCabinet, canUseManagement } from './cabinetAccess';
import { getAuthToken, setAuthToken, clearAuthToken } from './auth';


// auth_token_employee
// auth_token

export const LayoutContext = createContext();

// A client and an employee can have the same numeric ID. Keep the sender's
// explicit account kind, and accept employee photos only for employee notices.
function chatNoticeSender(notice) {
    if (notice?.sender_id == null || !['employee', 'client'].includes(notice?.sender_kind)) return null;
    return {
        id: notice.sender_id,
        kind: notice.sender_kind,
        name: notice.sender || '',
        avatar_url: notice.sender_kind === 'employee' ? notice.sender_avatar_url || null : null,
    };
}

// Запускает некритичную загрузку, когда браузер свободен (после первой отрисовки).
// Возвращает функцию отмены — для очистки в useEffect.
function runWhenIdle(fn, timeout = 1500) {
    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
        const id = window.requestIdleCallback(fn, { timeout });
        return () => { try { window.cancelIdleCallback?.(id); } catch (e) {} };
    }
    const id = setTimeout(fn, 300);
    return () => clearTimeout(id);
}


// Функция для получения токена
const getInitialToken = (location) => {
    const params = new URLSearchParams(location.search);
    if (params.get('token')) return false;
    return !getAuthToken();
};

// true только если есть что верифицировать
const shouldVerifyToken = (location) => {
    const params = new URLSearchParams(location.search);
    if (params.get('token')) return true;
    if (getAuthToken()) return true;
    return false;
};


export default function LayoutProvider({ children }) {
    const navigate = useNavigate();
    const location = useLocation();
    
    const [ sidebarOpen, setSidebarOpen ] = useState(false);

    const [ account, setAccount ] = useState({});
    const [ accountLoaded, setAccountLoaded ] = useState(false);
    const [ activeRole, setActiveRoleState ] = useState(localStorage.getItem('active_role') || null);

    const [ lock, setLock ] = useState(getInitialToken(location));
    const [ loadInitial, setLoadInitial ] = useState(shouldVerifyToken(location));

    // Токен Сотрудника 
    const [ tokenEmployee, setTokenEmployee ] = useState(null);
    // Список Событий
    const [ listEvents, setListEvents ] = useState([]);
    const eventFetchVersions = useRef(new Map());
    const eventFetchCounter = useRef(0);
    const [ loadListEvents, setLoadListEvents ] = useState(false);
    // Список ЗП Платежей
    const [ listPaymentEvents, setListPaymentEvents ] = useState([]);

    // Активные процессы выгрузки (complete / supplement)
    const [ uploadProcesses, setUploadProcesses ] = useState([]); 

    // Города
    const [ citys, setCitys ] = useState([]);
    // Сотрудники
    const [ employee, setEmployee ] = useState([]);
    // Флаг загрузки списка обмерщиков
    const [employeeLoading, setEmployeeLoading] = useState(false);
    // Сотрудники (Все типы)
    const [ employeeAll, setEmployeeAll ] = useState([]);
    // Программы
    const [ programs, setPrograms ] = useState([]);

    // Окно События
    const [ modalEvent, setModalEvent ] = useState({ event: null, open: false, preselectedApplication: null });
    const [ modalApplication, setModalApplication ] = useState({ open: false, application: null });
    // Окно
    const [ modalQuest, setModalQuest ] = useState({ id_event: null, open: false });
    // Окно добавления доп услуги
    const [ modalAddAdditionalService, setModalAddAdditionalService ] = useState({ id_pay_event: null, paymentEvent: null, setPaymentEvent: null , open: false });
    // Окно расшифровки суммы выплаты
    const [ modalPaymentBreakdown, setModalPaymentBreakdown ] = useState({ open: false, paymentId: null, onUpdated: null });
    // ── Всплывающие уведомления вместо alert() ──
    // alert блокирует интерфейс, показывает по одному сообщению и не различает
    // предупреждение и ошибку. Для сценариев «выплата проведена»,
    // «услуга используется», «Битрикс недоступен» этого недостаточно.
    const [ toasts, setToasts ] = useState([]);
    // Доп услуги
    const [ additionalServices, setAdditionalServices ] = useState([]);
    const [ modalAddEventService, setModalAddEventService ] = useState({ 
        open: false,
        onSave: () => {} 
    });
    // Состояние даты месяца
    const [dateRange, setDateRange] = useState({
        startDate: null,
        endDate: null
    });
    // Модальное окно отзыва о сотруднике
    const [ modalReviewEmployee, setModalReviewEmployee ] = useState({ open: false, event: null, employee_leaving: null, about_employee: null });

    // Модальное окно подтверждения удаления файла
    const [ modalConfirmDeleteFile, setModalConfirmDeleteFile ] = useState({ file: null, event: null, bitrix_deal_id: null, open: false });
    // Список файлов в модальном окне события
    const [ files, setFiles ] = useState([]);

    // Модальное окно Профиля
    const [ modalProfile, setModalProfile ] = useState(false);
    // Модальное окно Заврешения обмера
    const [ modalCompleteEvent, setCompleteModalEvent ] = useState({ event: null, open: false });
    // Модальное окно для подключения консоли
    const [ modalKonsolConnect, setModalKonsolConnect ] = useState(false);
    // Модальное окно неуспешного завершения события со стороны обмерщика
    const [ modalFailEvent, setFailModalEvent ] = useState({ event: null, open: false });
    // Модальное окно дополнения события 
    const [ modalSupplementEvent, setSupplementModalEvent ] = useState({ event: null, open: false });
    // Модальное окно просроченных событий 
    const [ modalOverdueEvents, setModalOverdueEvents ] = useState({ open: false, events: [] });
    // Сторис новостей: items — новости со слайдами, preview — режим предпросмотра (без статистики)
    const [ newsStories, setNewsStories ] = useState({ open: false, items: [], preview: false });
    // Лента сторис для шапки (включая просмотренные — для пересмотра)
    const [ storiesBar, setStoriesBar ] = useState({ items: [], loaded: false });
    // Модальное окно чата сообщений
    const [ chatModal, setChatModal ] = useState({ open: false, chatId: null, chatName: null });
    const chatNoticeGateRef = useRef(createChatNoticeGate());
    const currentChatRef = useRef(null);
    currentChatRef.current = openChatId(location, chatModal);
    const shouldShowChatNotice = notice => chatNoticeGateRef.current.accept(notice, {
        activeChatId: currentChatRef.current,
        visible: typeof document === 'undefined' || document.visibilityState === 'visible',
        focused: typeof document === 'undefined' || typeof document.hasFocus !== 'function' || document.hasFocus(),
    });
    useEffect(() => { chatNoticeGateRef.current.clear(); }, [tokenEmployee, account?.id]);

    // Модальное окно Экран откликов
    const [ modalDispatchResponses, setModalDispatchResponses ] = useState({ open: false, dispatchId: null });

    // Модальное окно теста PUSH
    const [modalTestPush, setModalTestPush] = useState(false);
    const [modalIOSNotifHelp, setModalIOSNotifHelp] = useState(false);

    const [unreadCounts, setUnreadCounts] = useState({
        unread_counts: [],
        timestamp: 0
    });

    const [ notificationSocket, setNotificationSocket ] = useState(null);
    const [ notificationWsConnected, setNotificationWsConnected ] = useState(false);
    const [ notifications, setNotifications ] = useState([]);
    const [ chats, setChats ] = useState([]);

    const [ centerNotifs, setCenterNotifs ] = useState([]);   // список уведомлений (центр)
    const [ notifUnread, setNotifUnread ] = useState(0);      // счётчик непрочитанных
    const [ notifPanelOpen, setNotifPanelOpen ] = useState(false); // открыта ли панель

    const [coverageOnboardingNeeded, setCoverageOnboardingNeeded] = useState(false);
    const [coverageOnboardingChecked, setCoverageOnboardingChecked] = useState(false);

    const [ openNotif, setOpenNotif ] = useState({
        timestamp: null,
        open: false,
        text: null,
        chat: null,
        sender: null,
        sender_person: null,
    });

    const [ modalEmployee, setModalEmployee ] = useState({
        open: false,
        employee: null,
        onSave: null
    });

    const [ dealList, setDealList ] = useState([]);
    const [ loadDealList, setLoadDealList ] = useState(false);

    const { playSound } = useSound();
    const notificationInitializedRef = useRef(false);

    // Тех поддержка
    const [ modalTicketSupport, setModalTicketSupport ] = useState(false);
    const [ techSupportTickets, setTechSupportTickets ] = useState([]);
    const [ loadTechSupport, setLoadTechSupport ] = useState(false);
    // Модальное окно базы знаний
    const [modalKnowledge, setModalKnowledge] = useState({ open: false, article: null });

    // Уведомление в браузере
    const [ modalNotification, setModalNotification ] = useState({
        open: false,
        type: 'default' // new_activate
    });

    const employeeLoadingRef = useRef(false);

    // ── Заявки клиентов (панель менеджера) ───────────────────
    // Список заявок
    const [ applicationsList, setApplicationsList ] = useState([]);
    const [ applicationsLoading, setApplicationsLoading ] = useState(false);
    // Счётчики с сервера: для бейджей на вкладках «Черновики»/«Скрытые».
    const [ applicationsCounts, setApplicationsCounts ] = useState({ total: 0, draft_count: 0, hidden_count: 0 });
    // Счётчик незакреплённых (для бейджа)
    const [ unassignedAppsCount, setUnassignedAppsCount ] = useState(0);
    // Открыта ли панель заявок (можно сворачивать влево)
    const [ applicationsPanelOpen, setApplicationsPanelOpen ] = useState(true);
    // Какая заявка сейчас выбрана для просмотра чата (id) или null
    const [ selectedApplicationId, setSelectedApplicationId ] = useState(null);

    const [ pendingPerformersCount, setPendingPerformersCount ] = useState(0);

    const [ boardRefreshKey, setBoardRefreshKey ] = useState(0);
    const bumpBoardRefresh = useCallback(() => setBoardRefreshKey(k => k + 1), []);

    useEffect(() => {eventFetchVersions.current.clear();setListEvents([]);}, [tokenEmployee, account?.id]);


    // useEffect(() => {
    //     const _tg = window?.Telegram?.WebApp;
    //     // отключить вертикальный свайп
    //     _tg?.disableVerticalSwipes();
        
    //     // Сообщаем Telegram, что WebApp готово
    //     _tg?.ready();
    //     _tg?.expand();

    //     // Настраиваем цвет верхней шапки ТГ
    //     // _tg?.setHeaderColor('#8854e8ff');
    //     // _tg?.setBackgroundColor('#ffffffff');
    // }, []);

    const notify = useCallback((text, kind = 'neutral', ttl = 5000) => {
        if (!text) return;
        const id = Date.now() + Math.random();
        setToasts((p) => [...p, { id, text, kind }]);
        if (ttl) setTimeout(() => setToasts((p) => p.filter((t) => t.id !== id)), ttl);
    }, []);
    const dismissToast = useCallback((id) => setToasts((p) => p.filter((t) => t.id !== id)), []);

    // Верификация токена пользователя
    const verifyToken = async () => {
        try {
            // Получаем токен из URL или куков
            const params = new URLSearchParams(location.search);
            const urlToken = params.get('token');
            const cookieToken = getAuthToken();

            const authToken = urlToken || cookieToken;
            if (!authToken) {
                throw new Error('Токен не найден');
            }

            const response = await APIVerifyToken(authToken);
            
            setLoadInitial(false);
            // Сохраняем токен и данные
            setTokenEmployee(authToken);
            setAuthToken(authToken);
            setAccount(response);
            setLock(false);
            setAccountLoaded(true);
            
            // Сохраняем токен в куки
            Cookies.set('auth_token_employee', authToken, { expires: 7 }); // 7 день
            
            // Убираем токен из URL
            if (urlToken) {
                // Используем актуальный pathname, а не из замыкания
                navigate(window.location.pathname, { replace: true });
            }
            
        } catch (error) {
            console.error('Ошибка верификации:', error);
            setLoadInitial(false);
            setAccountLoaded(true);

            const status = error?.response?.status;
            if (status === 401 || status === 403) {
                // Токен реально невалиден — на LockPage
                setLock(true);
            } else {
                // Если токен был — оставляем юзера залогиненным, иначе → LockPage
                if (!getAuthToken()) setLock(true);
            }
        }
    };

    useEffect(() => {
        // Ждём, пока verifyToken установит токен. До этого ничего не дёргаем.
        if (!tokenEmployee) return;

        // Критично (аккаунт → права/маршруты) — грузим сразу.
        if (!account?.position?.includes('surveyor')) {
            getEmployee();
        }

        // Справочники нужны только в модалке события (город/программы/чертёжник),
        // а не для первой отрисовки доски. Уводим в idle, чтобы не конкурировать
        // с загрузкой канбана. У пикеров есть состояние загрузки — задержка их не ломает.
        const cancel = runWhenIdle(() => {
            if (canUseManagement(account)) getEmployeeAll();
            if (canUseManagement(account) || account?.position?.includes('surveyor') || account?.position?.includes('draftsman')) {
                getPrograms();
                getCitys();
            }
        });
        return cancel;
    }, [tokenEmployee]);

    
    

    const availableCabinets = getAvailableCabinets(account);
    const effectiveRole = resolveCabinet(account, activeRole);

    const switchRole = useCallback((role) => {
        if (!getAvailableCabinets(account).includes(role)) return;
        localStorage.setItem('active_role', role);
        setActiveRoleState(role);
        setSidebarOpen(false);
        navigate(getHomePathForRole(role), { replace: true });
    }, [account, navigate]);

    // Исправляет старый quality_master у чертёжника и роль, снятую администратором.
    useEffect(() => {
        if (!accountLoaded) return;
        if (effectiveRole) localStorage.setItem('active_role', effectiveRole);
        else localStorage.removeItem('active_role');
        if (activeRole !== effectiveRole) setActiveRoleState(effectiveRole);
    }, [accountLoaded, effectiveRole, activeRole]);

    const refreshPendingPerformers = async () => {
        if (!tokenEmployee || !canUseManagement(account)) return;
        try {
            const data = await APIGetPendingRegistrations(tokenEmployee);
            setPendingPerformersCount((data?.results || []).length);
        } catch (e) {
            // молча — точка просто не загорится
        }
    };

    useEffect(() => {
        if (tokenEmployee) refreshPendingPerformers();
    }, [tokenEmployee]);

    // Живое обновление прав: подтягиваем эффективные права аккаунта без
    // перезагрузки — сразу, по фокусу вкладки и раз в 60 сек. Так изменения
    // ролей администратором применяются у пользователя без релогина.
    const permissionRequest = useRef(0);
    const permissionToken = useRef(tokenEmployee);
    const permissionSnapshot = useRef('');
    permissionToken.current = tokenEmployee;
    const refreshMyPermissions = async () => {
        if (!tokenEmployee) return;
        const requestId = ++permissionRequest.current;
        try {
            const data = await APIMyPermissions(tokenEmployee);
            if (requestId !== permissionRequest.current || permissionToken.current !== tokenEmployee) return;
            if (data?._isAuthError) {
                clearAuthToken();
                setAccount({});
                setTokenEmployee(null);
                setLock(true);
                return;
            }
            if (data?._error) return;
            if (Array.isArray(data?.permissions)) {
                setAccount(prev => {
                    // Ничего не изменилось → возвращаем прежний объект, чтобы не
                    // плодить новую ссылку и не будить эффекты по всему приложению.
                    const next = {
                        ...prev,
                        permissions: data.permissions,
                        access_scope: data.scope ?? prev?.access_scope,
                        position: data.position ?? prev?.position,
                        role: data.role ?? prev?.role,
                        cabinet_access: data.cabinet_access ?? prev?.cabinet_access,
                        region_id: data.region_id ?? null,
                        region_name: data.region_name ?? null,
                    };
                    const keys = ['permissions', 'access_scope', 'position', 'role', 'cabinet_access', 'region_id', 'region_name'];
                    return keys.every((key) => JSON.stringify(prev?.[key]) === JSON.stringify(next[key]))
                        ? prev : next;
                });
                const snapshot = JSON.stringify(data);
                if (permissionSnapshot.current !== snapshot) {
                    permissionSnapshot.current = snapshot;
                    window.dispatchEvent(new Event('access:refreshed'));
                }
            }
        } catch (e) { /* временная ошибка не стирает текущие права */ }
    };

    useEffect(() => {
        if (!tokenEmployee) return;
        refreshMyPermissions();
        const onFocus = () => refreshMyPermissions();
        const onStorage = e => { if (e.key === ACCESS_UPDATE_KEY) refreshMyPermissions(); };
        const onVisible = () => { if (document.visibilityState === 'visible') refreshMyPermissions(); };
        window.addEventListener('focus', onFocus);
        window.addEventListener('access:changed', onFocus);
        window.addEventListener('storage', onStorage);
        document.addEventListener('visibilitychange', onVisible);
        const id = setInterval(onVisible, 60000);
        return () => {
            ++permissionRequest.current;
            window.removeEventListener('focus', onFocus);
            window.removeEventListener('access:changed', onFocus);
            window.removeEventListener('storage', onStorage);
            document.removeEventListener('visibilitychange', onVisible);
            clearInterval(id);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenEmployee]);

    // Получаем сотрудника
    function getEmployee() {
        const token = getAuthToken() || tokenEmployee;
        if (!token) return;

        APIGetEmployee(token).then((data) => {
            // Сеть/сервер моргнули — НЕ выкидываем, пользователь останется залогинен
            if (data?._error && !data?._isAuthError) {
                console.warn('getEmployee: временная ошибка, остаёмся в аккаунте', data._status);
                return;
            }
            // Только реально невалидный токен (401/403) ведёт к выходу
            if (data?._isAuthError) {
                clearAuthToken();
                setLock(true);
                return;
            }
            if (!data?.employee) {
                console.warn('getEmployee: ответ без employee, не трогаем сессию', data);
                return;
            }

            const employee = data.employee;
            setAccount(prev => ({ ...prev, ...employee }));
        });
    }
    
    useEffect(() => {
        verifyToken();
    }, []);



    
    const uploadProcessesRef = useRef([]);

    const addUploadProcess = useCallback(({ process_id, type, event_name, event_id, status = 'pending' }) => {
        if (status === 'done') {
            uploadProcessesRef.current = uploadProcessesRef.current.filter(p => String(p.process_id) !== String(process_id));
            setUploadProcesses([...uploadProcessesRef.current]);
            return;
        }
        const newProcess = { process_id, type, event_name, event_id, status, started_at: Date.now() };
        uploadProcessesRef.current = [...uploadProcessesRef.current.filter(p => String(p.process_id) !== String(process_id)), newProcess];
        setUploadProcesses([...uploadProcessesRef.current]);
    }, []);

    const removeUploadProcess = useCallback((process_id) => {
        uploadProcessesRef.current = uploadProcessesRef.current.filter(p => p.process_id !== process_id);
        setUploadProcesses([...uploadProcessesRef.current]);
    }, []);

    const updateUploadProcessStatus = useCallback((process_id, status, detail = {}) => {
        uploadProcessesRef.current = uploadProcessesRef.current.map(p =>
            p.process_id === process_id ? { ...p, status, error_message: detail.error_message || '', retryable: Boolean(detail.retryable) } : p
        );
        setUploadProcesses([...uploadProcessesRef.current]);
    }, []);

    useEffect(() => {
        // Local hints belong to one account. Authorized event snapshots restore
        // any surviving process after a refresh or a change of session.
        uploadProcessesRef.current = [];
        setUploadProcesses([]);
        if (!tokenEmployee) return;
        let disposed = false, inFlight = false;
        const removals = new Set();
        const poll = async () => {
            if (disposed || inFlight) return;
            inFlight = true;
            try {
                const active = uploadProcessesRef.current.filter(p => ['uploading', 'pending', 'processing'].includes(p.status));
                for (const proc of active) {
                    const fn = proc.type === 'supplement' ? APIGetSupplementStatus : APIGetCompletionStatus;
                    const result = await fn(proc.process_id, tokenEmployee);
                    if (disposed) return;
                    // A failed HTTP/status request does not change the process.
                    if (!['uploading', 'pending', 'processing', 'done', 'failed'].includes(result?.status)) continue;
                    updateUploadProcessStatus(proc.process_id, result.status, result);
                    if (result.status === 'done') {
                        const timer = setTimeout(() => {
                            removals.delete(timer);
                            if (!disposed) removeUploadProcess(proc.process_id);
                        }, 5000);
                        removals.add(timer);
                        if (location.pathname.startsWith('/surveyor') && account?.position?.includes('surveyor')) {
                            updateListEvents(null, account.id);
                        }
                    }
                }
            } catch { /* Keep the last confirmed status on a transport failure. */ }
            finally { inFlight = false; }
        };
        const interval = setInterval(poll, 5000);
        return () => {
            disposed = true;
            clearInterval(interval);
            removals.forEach(clearTimeout);
        };
    }, [tokenEmployee, account?.id]);

    // Загружаем, проверяем есть ли фоновые процессы на загрузку в яндекс диск
    // useEffect(() => {
    //     if (!tokenEmployee || !account?.position?.includes('surveyor')) return;
        
    //     APIGetActiveProcesses(tokenEmployee).then(data => {
    //         if (data?.processes?.length) {
    //             uploadProcessesRef.current = data.processes;
    //             setUploadProcesses(data.processes);
    //         }
    //     });
    // }, [tokenEmployee, account]);


    // Получить Города
    function getCitys() {
        const token = Cookies.get("auth_token") || tokenEmployee; // Извлекаем токен из cookies
        if (!token) return;
        // Сортировка по алфавиту (страховка на случай старого кеша/порядка с сервера)
        const sortByName = (arr) =>
            [...(arr || [])].sort((a, b) => (a?.name || '').localeCompare(b?.name || '', 'ru'));
        // Мгновенно из кеша сессии, затем обновляем с сервера.
        try {
            const cached = sessionStorage.getItem('dict_citys');
            if (cached) setCitys(sortByName(JSON.parse(cached)));
        } catch (e) { /* ignore */ }
        APIGetCitys(token).then((data) => {
            if (data?.length) {
                const sorted = sortByName(data);
                setCitys(sorted);
                try { sessionStorage.setItem('dict_citys', JSON.stringify(sorted)); } catch (e) { /* ignore */ }
            }
        });
    }

    // Справочник исполнителей «для выбора».
    // Ручки /employee-list/ и /employee-all/ закрыты правом performers.view —
    // это право на РАЗДЕЛ «Исполнители». У менеджера по качеству его нет, он
    // получал 403, список молча превращался в пустой массив, и все выпадающие
    // списки исполнителей выглядели просто пустыми, без единой ошибки.
    // /employee-choices/ прав не требует и отдаёт только имена и должности.
    function loadEmployeeChoices(position = null) {
        const token = Cookies.get("auth_token") || tokenEmployee;
        if (!token) return Promise.resolve([]);
        return APIGetEmployeeChoices(token, position)
            .then((data) => (Array.isArray(data) ? data : []))
            .catch(() => []);
    }

    // Получить Обмерщиков
    function getEmployeeList() {
        if (employeeLoadingRef.current) return; // уже грузится
        const token = Cookies.get("auth_token") || tokenEmployee;
        if (token) {
            employeeLoadingRef.current = true;
            setEmployeeLoading(true);
            APIGetEmployeesList(token).then((data) => {
                if (data?.length) {
                    const unique = data.filter((emp, idx, arr) => 
                        arr.findIndex(e => e.id === emp.id) === idx
                    );
                    setEmployee(unique);
                    return null;
                }
                // Пусто — почти всегда это 403 на /employee-list/.
                // Возвращаем промис из .then, поэтому .finally (а с ним и
                // employeeLoading) дождётся запасного запроса, и модалка
                // не покажет «список пуст» раньше времени.
                return loadEmployeeChoices('surveyor').then((rows) => {
                    if (rows.length) setEmployee(rows);
                });
            }).finally(() => {
                employeeLoadingRef.current = false;
                setEmployeeLoading(false);
            });
        }
    }

    // Получить Обмерщиков Всех
    function getEmployeeAll() {
        const token = Cookies.get("auth_token") || tokenEmployee;
        if (!token) return;
        APIGetEmployeesAll(token)
            .then((data) => {
                if (Array.isArray(data) && data.length) {
                    setEmployeeAll(data);
                    return null;
                }
                // Нет права на раздел «Исполнители» либо список пуст.
                // Подставляем облегчённый справочник: без телефонов и почты,
                // но с именами и должностями — выпадающие списки оживают.
                // Раздел «Исполнители» при этом остаётся закрыт: маршрут
                // /performers защищён тем же правом на фронте и на сервере.
                return loadEmployeeChoices().then((rows) => setEmployeeAll(rows));
            })
            .catch((err) => console.error('getEmployeeAll error:', err));
    }

    // Получить Программы
    function getPrograms() {
        const token = Cookies.get("auth_token") || tokenEmployee; // Извлекаем токен из cookies
        if (!token) return;
        try {
            const cached = sessionStorage.getItem('dict_programs');
            if (cached) setPrograms(JSON.parse(cached));
        } catch (e) { /* ignore */ }
        APIGetPrograms(token).then((data) => {
            if (data?.length) {
                setPrograms(data);
                try { sessionStorage.setItem('dict_programs', JSON.stringify(data)); } catch (e) { /* ignore */ }
            }
        });
    }

    // useEffect(() => {
    //     getEmployee();
    //     getEmployeeAll();
    //     getPrograms();
    //     getCitys();
    // }, [account]);

    const refreshNotifs = useCallback(async () => {
        if (!tokenEmployee) return;
        const data = await APIGetNotifications(tokenEmployee);
        setCenterNotifs(data?.results || []);
        setNotifUnread(data?.unread || 0);
    }, [tokenEmployee]);

    const markNotifRead = useCallback(async (id) => {
        setCenterNotifs(prev => prev.map(n => n.id === id ? { ...n, is_read: true } : n));
        setNotifUnread(prev => Math.max(0, prev - 1));
        await APIMarkNotificationRead(id, tokenEmployee);
    }, [tokenEmployee]);

    const markAllNotifsRead = useCallback(async () => {
        setCenterNotifs(prev => prev.map(n => ({ ...n, is_read: true })));
        setNotifUnread(0);
        await APIMarkAllNotificationsRead(tokenEmployee);
    }, [tokenEmployee]);

    useEffect(() => {
        if (tokenEmployee) refreshNotifs();
    }, [tokenEmployee, refreshNotifs]);


    // Вызов происходит после рендера, когда хук уже инициализирован.
    const loadsUnreadCounts = () => refreshPersonalUnread();

    async function markAsRead(chatId, messageIds = null) {
        if (!tokenEmployee || !chatId || !Array.isArray(messageIds) || !messageIds.length) return;
        try {
            const uniqueIds = [...new Set(messageIds)];
            for (let i = 0; i < uniqueIds.length; i += 300) {
                await APIMarkMessagesAsRead(chatId, uniqueIds.slice(i, i + 300), tokenEmployee);
            }
        } finally {
            await refreshPersonalUnread();
        }
    }

    const refreshPersonalUnread = usePersonalChatRealtime({
        token: tokenEmployee, actorId: account?.id,
        setSnapshot: setUnreadCounts, onStatus: setNotificationWsConnected,
        onNotification: (data) => {
        const timestamp = Date.now();
        switch (data.type) {
                        case 'new_message': {
                            // Реакция приходит тем же каналом, но НОВЫМ СООБЩЕНИЕМ
                            // не является: она не должна ни поднимать счётчик
                            // непрочитанного, ни подменять превью последнего
                            // сообщения в списке чатов. Иначе у человека в
                            // списке вместо реплики висит «😀 реакция на: …»
                            // и горит единичка, которую нечем погасить.
                            const isReaction = data?.data?.kind === 'reaction';

                            if (shouldShowChatNotice(data?.data)) {
                                playSound('message');
                                setOpenNotif({
                                    timestamp: data?.data?.timestamp || Date.now(),
                                    open: true,
                                    text: data?.data?.content,
                                    chat: data?.data?.name_chat,
                                    sender: data?.data?.sender,
                                    sender_person: chatNoticeSender(data?.data),
                                    chatId: data?.data?.chat_id,
                                });
                            }

                            // Обновляем last_message в соответствующем чате
                            if (!isReaction) setChats(prevChats => {
                                return prevChats.map(chat => 
                                    chat.chat_id === data.data.chat_id
                                        ? { 
                                            ...chat, 
                                            last_message: {
                                                id: data.data.message_id,
                                                content: data.data.content,
                                                date_create: data.data.date_create,
                                                type_sender: 'user',
                                                sender: data.data.sender_id != null ? {
                                                    id: data.data.sender_id,
                                                    kind: data.data.sender_kind || 'employee',
                                                    name: data.data.sender,
                                                    avatar_url: data.data.sender_kind === 'employee' ? data.data.sender_avatar_url || null : null,
                                                } : null,
                                            }
                                        }
                                        : chat
                                );
                            });

                            // Добавляем уведомление
                            setNotifications(prev => [
                                {
                                    id: Date.now(),
                                    type: isReaction ? 'reaction' : 'new_message',
                                    data: data.data,
                                    timestamp: new Date()
                                },
                                ...prev.slice(0, 49)
                            ]);
                            break;
                        }

                        case 'new_chat':
                            playSound('chat');
                            setNotifications(prev => [
                                {
                                    id: Date.now(),
                                    type: 'new_chat',
                                    data: data.data,
                                    timestamp: new Date()
                                },
                                ...prev.slice(0, 49)
                            ]);
                            break;
                            
                        case 'friend_status':
                            console.log('Статус друга изменился:', data.data);
                            break;

                        // Кто-то вошёл или вышел. В состояние контекста не
                        // кладём намеренно: статус меняется часто, а от него
                        // зависят две точки в списке чатов — перерисовывать
                        // ради них всё приложение незачем. Событие окна
                        // слушает тот, кому оно нужно.
                        case 'presence':
                            if (typeof window !== 'undefined') {
                                window.dispatchEvent(
                                    new CustomEvent('planium:presence', { detail: data.data })
                                );
                            }
                            break;
                            
                        case 'notification_message':
                            playSound('message');
                            setCenterNotifs(prev => [data.data, ...prev.slice(0, 99)]);
                            setNotifUnread(prev => prev + 1);
                            break;

                        case 'pong':
                            break;
                    }
        },
    });

    const unreadByChat = useMemo(() => Object.fromEntries(
        (unreadCounts.unread_counts || []).map(r => [String(r.chat_id), Number(r.unread_count) || 0]),
    ), [unreadCounts]);
    const getChatUnread = useCallback(chatId => unreadByChat[String(chatId)] || 0, [unreadByChat]);

    const totalUnread = unreadCounts?.unread_counts?.reduce((sum, item) => sum + item.unread_count, 0) || 0;


    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

    useEffect(() => {
        if (!('serviceWorker' in navigator)) return;

        // Читаем chatId из URL (/chats/?chatId=123)
        const getCurrentChatId = () => {
            return currentChatRef.current;
        };

        // Сообщаем SW текущее состояние — активен ли сайт и какой чат открыт
        const notifySW = (isActive) => {
            navigator.serviceWorker.ready.then(reg => {
                reg.active?.postMessage({
                    type: isActive ? 'site_active' : 'site_inactive',
                    chatId: isActive ? getCurrentChatId() : null  // ← вот и весь секрет
                });
            });
        };

        // Сразу сообщаем что активны
        const isForeground = () => !document.hidden && (!document.hasFocus || document.hasFocus());
        notifySW(isForeground());

        const handleVisibility = () => notifySW(isForeground());
        const handleFocus = () => notifySW(isForeground());
        const handleBlur = () => notifySW(false);

        document.addEventListener('visibilitychange', handleVisibility);
        window.addEventListener('focus', handleFocus);
        window.addEventListener('blur', handleBlur);

        // Слушаем сообщения от SW
        const handleSWMessage = (event) => {
            if (event.data?.type === 'push_received') {
                const data = event.data.data;
                const chatId = data.data?.chat_id;

                if (chatId && !shouldShowChatNotice({ ...data.data, content: data.body })) {
                    loadsUnreadCounts();
                    return;
                }
                playSound('message');
                setOpenNotif({
                    timestamp: Date.now(),
                    open: true,
                    text: data.body,
                    chat: chatId,
                    chatId,
                    sender: data.title,
                    sender_person: chatNoticeSender(data?.data),
                });

                if (chatId) loadsUnreadCounts();
            }

            if (event.data?.type === 'navigate') {
                navigate(event.data.url);
            }
        };

        navigator.serviceWorker.addEventListener('message', handleSWMessage);

        // ← Новое: при смене URL (пользователь открыл/закрыл чат) — обновляем SW
        const handleLocationChange = () => {
            if (!document.hidden) notifySW(true);
        };
        window.addEventListener('popstate', handleLocationChange);

        return () => {
            notifySW(false);
            document.removeEventListener('visibilitychange', handleVisibility);
            window.removeEventListener('focus', handleFocus);
            window.removeEventListener('blur', handleBlur);
            window.removeEventListener('popstate', handleLocationChange);
            navigator.serviceWorker.removeEventListener('message', handleSWMessage);
        };
    }, [tokenEmployee]);

    useEffect(() => {
        if (!('serviceWorker' in navigator)) return;
        if (document.hidden) return; // если вкладка скрыта — не нужно

        const isActive = !document.hidden && (!document.hasFocus || document.hasFocus());
        navigator.serviceWorker.ready.then(reg => {
            reg.active?.postMessage({
                type: isActive ? 'site_active' : 'site_inactive',
                chatId: isActive ? currentChatRef.current : null,
            });
        });
    }, [location, chatModal.open, chatModal.chatId]);

    useEffect(() => {
        if (!account || !tokenEmployee) return;
        if (!account?.position?.includes('surveyor')) return;

        APIGetOverdueEvents(tokenEmployee).then(data => {
            if (data?.count > 0) {
                setModalOverdueEvents({ open: true, events: data.results });
            }
        });
    }, [account?.id, tokenEmployee]);

    // ── Сторис новостей: одна проверка за сессию, без навязчивости ────────────
    // Не показываем: на публичных/рабочих экранах обмерщика, пока открыта
    // модалка просрочек и пока не прогрузился аккаунт.
    const NEWS_BLOCKED_PATHS = [
        '/privacy-policy', '/surveyor/close', '/surveyor/fail',
        '/surveyor/arrive', '/surveyor/supplement',
    ];

    const loadNewsFeed = useCallback(async ({ force = false } = {}) => {
        const token = getAuthToken() || tokenEmployee;
        if (!token) return;
        if (!force && sessionStorage.getItem('news_feed_checked') === '1') return;

        try {
            const data = await APIGetNewsFeed(token);
            sessionStorage.setItem('news_feed_checked', '1');
            const items = (data?.results || []).filter(n => (n?.slides || []).length > 0);
            if (items.length > 0) {
                setNewsStories({ open: true, items, preview: false });
            }
        } catch (e) {
            console.warn('[news feed]', e);
        }
    }, [tokenEmployee]);

    const storiesInFlightRef = useRef(null);
    const loadStoriesBar = useCallback(async () => {
        const token = getAuthToken() || tokenEmployee;
        if (!token) return;
        // Дедуп: HeaderLK и DesktopStoriesWidget зовут это одновременно —
        // переиспользуем один и тот же запрос вместо двух.
        if (storiesInFlightRef.current) return storiesInFlightRef.current;
        const p = (async () => {
            try {
                const data = await APINewsStories(token);
                const items = (data?.results || []).filter(n => (n?.slides || []).length > 0);
                setStoriesBar({ items, loaded: true });
            } catch (e) {
                console.warn('[stories bar]', e);
            } finally {
                storiesInFlightRef.current = null;
            }
        })();
        storiesInFlightRef.current = p;
        return p;
    }, [tokenEmployee]);

    useEffect(() => {
        if (!account?.id || !tokenEmployee) return;
        if (modalOverdueEvents.open) return;
        if (NEWS_BLOCKED_PATHS.some(p => location.pathname.startsWith(p))) return;

        // Небольшая задержка, чтобы не спорить с загрузкой основного экрана
        const timer = setTimeout(() => { loadNewsFeed(); }, 1500);
        return () => clearTimeout(timer);
    }, [account?.id, tokenEmployee, modalOverdueEvents.open, location.pathname, loadNewsFeed]);

    useEffect(() => {
        return () => {
            // Закрываем WebSocket соединение при размонтировании приложения
            if (notificationSocket) {
                notificationSocket.close();
            }
        };
    }, [notificationSocket]);

    useEffect(() => {
        if (!tokenEmployee) return;

        const checkAndRestoreSubscription = async () => {
            try {
                // Только если браузер поддерживает push
                const reg = await navigator.serviceWorker?.ready;
                if (!reg?.pushManager) return;

                const existingSub = await reg.pushManager.getSubscription();
                
                if (existingSub) {
                    // Подписка в браузере есть — проверяем есть ли она на сервере
                    const deviceToken = localStorage.getItem('push_device_token');
                    
                    if (deviceToken) {
                        const result = await APICheckPushByToken(tokenEmployee, deviceToken);
                        
                        if (!result.exists) {
                            // Подписка слетела на сервере — пересоздаём автоматически
                            console.log('Push subscription lost on server, re-registering...');
                            await subscribeUserToPush(tokenEmployee);
                        }
                        // Если exists: true — всё хорошо, ничего не делаем
                    }
                }
                // Если подписки в браузере нет — пользователь сам должен нажать кнопку
            } catch (e) {
                console.warn('Push subscription check failed:', e);
            }
        };

        checkAndRestoreSubscription();
    }, [tokenEmployee]);

    // Функция для загрузки всех сделок с пагинацией
    async function getDeals() {
        if (!canUseManagement(account)) return;
        console.log("Начало загрузки сделок Bitrix...");
        
        let allDeals = [];
        let currentPage = 1;
        let hasMorePages = true;
        
        setLoadDealList(true);
        try {
            while (hasMorePages) {
                console.log(`Загрузка страницы ${currentPage}...`);
                
                const response = await APIGetListDeal(currentPage, 500);
                
                if (response && response.deals) {
                    // Добавляем сделки текущей страницы к общему списку
                    allDeals = [...allDeals, ...response.deals];
                    
                    // Проверяем, есть ли еще страницы
                    hasMorePages = response.pagination?.has_next || false;
                    currentPage++;
                    
                    console.log(`Загружено ${response.deals.length} сделок со страницы ${response.pagination?.current_page}. Всего: ${allDeals.length}`);
                    
                    // Обновляем состояние после каждой страницы для прогрессивного отображения
                    setDealList([...allDeals]);
                    
                    // Небольшая задержка между запросами чтобы не нагружать сервер
                    if (hasMorePages) {
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }
                } else {
                    console.error('Ошибка при загрузке страницы:', response);
                    hasMorePages = false;
                }
            }
            
            console.log(`Загрузка завершена. Всего загружено ${allDeals.length} сделок`);
            
        } catch (error) {
            console.error('Ошибка при загрузке сделок:', error);
        } finally {
            setLoadDealList(false);
        }
    };

    // Функция для принудительного обновления сделок (сброс к первой странице)
    // const refreshDeals = useCallback(() => {
    //     setDealList([]); // Очищаем текущий список
    //     getDeals(); // Запускаем загрузку заново
    // }, [getDeals]);

    function getPaymentEvents() {
        if (!canUseManagement(account)) return;
        const token = Cookies.get("auth_token") || tokenEmployee;
        APIGetPaymentEvent(1, 20, 'all', null, null, null, null, token).then((data) => {
            if (data?.length) {
                console.log("PaymentEvent", data);
                setListPaymentEvents(data);
            }
        })
    }

    // Функция для загрузки списка доп. услуг
    function getAdditionalServices() {
        // Получаем токен из URL или куков
        const params = new URLSearchParams(location.search);
        const urlToken = params.get('token');
        if (!urlToken) {
            const token = Cookies.get("auth_token"); // Извлекаем токен из cookies
            if (token) {
                try {
                    const cached = sessionStorage.getItem('dict_additional_services');
                    if (cached) setAdditionalServices(JSON.parse(cached));
                } catch (e) { /* ignore */ }
                APIGetAdditionalService(token).then((data) => {
                    if (data?.length) {
                        setAdditionalServices(data);
                        try { sessionStorage.setItem('dict_additional_services', JSON.stringify(data)); } catch (e) { /* ignore */ }
                    }
                });
            }
        }
        
    }

    useEffect(() => {
        // Доп. услуги нужны только в модалке события — не тормозим ими доску.
        const cancel = runWhenIdle(() => getAdditionalServices());
        return cancel;
    }, []);

    // Стрим отслеживания обновлений с базы
    // useEffect(() => {
    //     const eventSource = new EventSource(API_URL + "/bitrix/sse/change-bitrix-deal/");
      
    //     eventSource.onmessage = (event) => {
    //         const data = JSON.parse(event.data);
    //         console.log("Получено событие:", data);

    //         // if (data.action === "create") {
    //         //     console.log("Новая сделка:", data.deal);
    //         // } else if (data.action === "update") {
    //         //     console.log("Обновленная сделка:", data.deal);
    //         // } else if (data.action === "delete") {
    //         //     console.log("Обновленная сделка:", data.deal);
    //         // }
    //     };
      
    //     eventSource.onerror = (error) => {
    //       console.error("Ошибка SSE:", error);
    //       eventSource.close();
    //     };
      
    //     return () => {
    //       eventSource.close();
    //     };
    // }, []);


    // Подгружаем события
    async function updateListEvents(type, empl_id, start_date = dateRange.startDate, end_date = dateRange.endDate, clear = false, clear_all = false) {
        const key = JSON.stringify([type, empl_id, start_date, end_date, tokenEmployee]);
        const version = ++eventFetchCounter.current;
        eventFetchVersions.current.set(key, version);
        setLoadListEvents(true);
        try {
            const data = await APIGetEvents(type, empl_id, start_date, end_date);
            if (eventFetchVersions.current.get(key) !== version || !Array.isArray(data)) return;
            const personalSurvey = (String(empl_id) === String(account?.id)
                || (empl_id == null && location.pathname.startsWith('/surveyor')))
                && account?.position?.includes('surveyor') && !['drawing', 'drawinganduser'].includes(type);
            setListEvents(previous => reconcileEvents(previous, data, {
                replaceAll: clear_all || (personalSurvey && !(start_date && end_date)),
                replaceRange: (clear || personalSurvey) && Boolean(start_date && end_date),
                start: start_date, end: end_date,
            }));
            setBoardRefreshKey(k => k + 1);
        } finally {
            if (eventFetchVersions.current.get(key) === version) setLoadListEvents(false);
        }
    }

    const setCurrentDateRange = (start, end) => {
        setDateRange({
            startDate: start,
            endDate: end
        });
    };



    // ── Загрузить список заявок ──────────────────────────────
    const loadApplications = useCallback(async (filters = {}, { silent = false } = {}) => {
        const token = Cookies.get("auth_token") || tokenEmployee;
        if (!token) return;

        // silent = true → не показываем лоадер (фоновое обновление)
        if (!silent) setApplicationsLoading(true);
        try {
            // Менеджерским спискам нужны и черновики, и скрытые. 
            // Разбиение активное/черновики/скрытые — на
            // клиенте, поэтому любой вызов с {} должен вернуть полный набор.
            const data = await APIGetManagerApplications(
                { include_drafts: true, include_hidden: true, light: true, ...filters },
                token,
            );
            if (data && Array.isArray(data.results)) {
                setApplicationsList(data.results);
                setApplicationsCounts({
                    total: data.total ?? data.results.length,
                    draft_count: data.draft_count ?? 0,
                    hidden_count: data.hidden_count ?? 0,
                });
            }
        } finally {
            if (!silent) setApplicationsLoading(false);
        }
        if (!silent) setBoardRefreshKey(k => k + 1); // обновляем канбан после сохранения заявки
    }, []);

    // ── Перезагрузить счётчик незакреплённых ─────────────────
    const refreshUnassignedCount = useCallback(async () => {
        const token = Cookies.get("auth_token") || tokenEmployee;
        if (!token) return;
        const count = await APIGetUnassignedApplicationsCount(token);
        setUnassignedAppsCount(count);
    }, []);

    // ── Свернуть/развернуть панель заявок ────────────────────
    const toggleApplicationsPanel = useCallback(() => {
        setApplicationsPanelOpen(prev => !prev);
    }, []);

    // ── Выбрать заявку (откроет нижнюю часть с чатом) ────────
    const selectApplication = useCallback((id) => {
        setSelectedApplicationId(prev => (prev === id ? null : id));
    }, []);

    // Подгружаем заявки и счётчик, когда залогинился менеджер.
    // ВАЖНО: зависимость — примитивы (роль + id), а НЕ объект account.
    // Иначе refreshMyPermissions (setAccount каждые 60с) пересоздаёт объект,
    // эффект перезапускается и снова дёргает тяжёлый loadApplications + новый интервал.
    const _isManagerRole = canUseManagement(account);
    useEffect(() => {
        if (!_isManagerRole) return;

        // Загружаем сразу при входе
        loadApplications();
        refreshUnassignedCount();

        // Фоновое обновление каждые 10 минут — тихо (без лоадера)
        const intervalId = setInterval(() => {
            if (document.hidden) return;   // не опрашиваем во вкладке в фоне
            loadApplications({}, { silent: true });
            refreshUnassignedCount();
        }, 10 * 60 * 1000);

        return () => clearInterval(intervalId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_isManagerRole, account?.id]);



    // Проверяем, поддерживаются ли push-уведомления
    const isPushSupported = () => {
        return (
            'serviceWorker' in navigator &&
            'PushManager' in window &&
            'Notification' in window
        );
    };

    const generateDeviceToken = () => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        return Array.from({length: 16}, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    };

    const getOrCreateDeviceToken = () => {
        let token = localStorage.getItem('push_device_token');
        if (!token) {
            token = generateDeviceToken();
            localStorage.setItem('push_device_token', token);
        }
        return token;
    };

    // Определяем платформу
    const getPlatform = () => {
        const ua = navigator?.userAgent || '';
        const uaLower = ua.toLowerCase();

        const isIOS = /iphone|ipod/.test(uaLower) || 
                    (/ipad/.test(uaLower)) ||
                    (navigator.maxTouchPoints > 1 && /macintosh/i.test(ua)); // iPad на iPadOS
        const isAndroid = /android/.test(uaLower);
        const isMobile = isIOS || isAndroid;

        if (isIOS) return 'ios';
        if (isAndroid) return 'android';
        if (/windows/.test(uaLower)) return 'windows';
        if (/mac/.test(uaLower)) return 'mac';
        return 'unknown';
    };

    // Проверяем мобильное ли устройство
    const isMobileDevice = () => {
        const ua = navigator?.userAgent || '';
        const uaLower = ua.toLowerCase();
        const isIOS = /iphone|ipod/.test(uaLower) ||
                    /ipad/.test(uaLower) ||
                    (navigator.maxTouchPoints > 1 && /macintosh/i.test(ua));
        const isAndroid = /android/.test(uaLower);
        return isIOS || isAndroid;
    };

    // Улучшенная функция подписки на push
    const subscribeUserToPush = async (token) => {
        try {
            // Сначала проверяем поддержку
            if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
            return { type: 'not_supported' };
            }

            // Проверяем текущий статус разрешения
            if (!('Notification' in window)) {
            return { type: 'not_supported' };
            }

            const permission = Notification.permission;
            
            // Если уже разрешено
            if (permission === 'granted') {
                const result = await processPushSubscription(token);
                if (result?.type === 'success') setModalTestPush(true);
                return result;
            }
            
            // Если отклонено - показываем инструкцию
            if (permission === 'denied') {
            // Не пытаемся запрашивать снова - показываем модальное окно с инструкцией
            setModalNotification({
                open: true,
                type: 'new_activate' // Показываем инструкцию для включения через настройки
            });
            return { type: 'permission_denied_permanent' };
            }
            
            // Если default - запрашиваем разрешение
            if (permission === 'default') {
                const newPermission = await window.Notification.requestPermission();
            if (newPermission === 'granted') {
                const result = await processPushSubscription(token);
                if (result?.type === 'success') setModalTestPush(true);
                return result;
            } else if (newPermission === 'denied') {
                setModalNotification({
                open: true,
                type: 'new_activate'
                });
                return { type: 'permission_denied' };
            }
            }

            return { type: 'unknown_error' };
            
        } catch (error) {
            console.error('Ошибка подписки на PUSH:', error);
            return { type: 'error', error: error.message };
        }
    };

    const processPushSubscription = async (token, showTest = false) => {
        try {
            // Регистрируем service worker
            let registration;
            try {
                registration = await navigator?.serviceWorker?.register('/sw.js', { scope: '/' });
                await navigator?.serviceWorker?.ready;
            } catch (swError) {
                console.error('Ошибка регистрации Service Worker:', swError);
                return { type: 'service_worker_error' };
            }

            // Проверяем существующую подписку
            let subscription = await registration?.pushManager?.getSubscription();

            // Если нет подписки — создаём
            if (!subscription) {
                const isIOS = /iPad|iPhone|iPod/.test(navigator?.userAgent);
                const isStandalone = window.navigator?.standalone || 
                                    window?.matchMedia('(display-mode: standalone)')?.matches;

                // На iOS без PWA — показываем инструкцию
                if (isIOS && !isStandalone) {
                    setModalNotification({ open: true, type: 'ios_install_required' });
                    return { type: 'ios_need_install' };
                }

                // Создаём подписку (работает и на iOS PWA 16.4+, и на Android, и на Desktop)
                try {
                    subscription = await registration?.pushManager?.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
                    });
                } catch (subscribeError) {
                    console.error('Ошибка создания подписки:', subscribeError);
                    return { type: 'subscribe_error', error: subscribeError.message };
                }
            }

            // Отправляем подписку на сервер
            return await sendSubscriptionToServer(subscription, token);
            
        } catch (error) {
            console.error('Ошибка подписки на PUSH:', error);
            return { type: 'error', error: error.message };
        }
    };

    // Функция отправки подписки на сервер
    const sendSubscriptionToServer = async (subscription, token) => {
        try {
            const p256dh = btoa(String.fromCharCode.apply(null, 
                new Uint8Array(subscription.getKey('p256dh'))));
            const auth = btoa(String.fromCharCode.apply(null, 
                new Uint8Array(subscription.getKey('auth'))));
            
            const subscriptionData = {
                endpoint: subscription?.endpoint,
                p256dh_key: p256dh,
                auth_key: auth,
                browser: navigator?.userAgent,
                platform: getPlatform(),
                employee_id: account?.id,
                is_standalone: window?.navigator?.standalone || false
            };

            const wasAlreadySubscribed = !!(await (await navigator.serviceWorker.ready)
                .pushManager.getSubscription());

            await APIRegisterPushSubscription(subscriptionData, token);
            console.log('PUSH подписка успешно сохранена');

            // Модалку теста показываем только если это НОВАЯ подписка
            // (пользователь только что нажал разрешить), а не фоновое восстановление
            // if (!wasAlreadySubscribed) {
            //     setModalTestPush(true);
            // }

            return { type: 'success', subscription };
        } catch (error) {
            console.error('Ошибка отправки подписки на сервер:', error);
            return { type: 'server_error', error };
        }
    };

    // ВАЖНО: Вставьте сюда ПУБЛИЧНЫЙ ключ, который вы сгенерировали в терминале (из предыдущего ответа про Django)
    const VAPID_PUBLIC_KEY = 'BABDBh5N_h8CYd-FEQaMHI0PiSzJV-axbKBF2dcLA-v6_B2E9_0IXSWryYTEqfF4CNTxJ5o8531JEOLHk77PXpk'; 

    // Для Android и Desktop
    const subscribeForOtherPlatforms = async (token) => {
        if (!isPushSupported()) {
            alert('Браузер не поддерживает push-уведомления');
            return { type: 'not_supported' };
        }

        try {
            // Регистрируем service worker
            const registration = await navigator?.serviceWorker?.register('/sw.js', {
                scope: '/'
            });

            // Ждем активации
            await navigator?.serviceWorker?.ready;

            // Проверяем подписку
            let subscription = await registration?.pushManager?.getSubscription();
            
            if (!subscription) {
                // Запрашиваем разрешение
                const permission = await window?.Notification?.requestPermission();
                
                if (permission !== 'granted') {
                    console.log('Пользователь отклонил уведомления');
                    return { type: 'permission_denied' };
                }

                subscription = await registration?.pushManager?.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
                });
            }

            // Формируем данные для сервера
            const p256dh = btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('p256dh'))));
            const auth = btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('auth'))));

            const deviceToken = getOrCreateDeviceToken();

            const subscriptionData = {
                endpoint: subscription?.endpoint,
                p256dh_key: p256dh,
                auth_key: auth,
                browser: navigator?.userAgent,
                platform: getPlatform(),
                employee_id: account?.id,
                is_standalone: window?.navigator?.standalone || false,
                device_token: deviceToken,
            };

            // Отправляем на сервер
            await APIRegisterPushSubscription(subscriptionData, token);
            
            console.log('PUSH подписка успешно сохранена');
            return { type: 'success', subscription };
            
        } catch (error) {
            console.error('Ошибка при подписке на PUSH:', error);
            return { type: 'error', error };
        }
    };

    // Функция для проверки и показа инструкций по установке PWA
    const checkPWAStatus = () => {
        const platform = getPlatform();
        const isMobile = isMobileDevice();
        const isStandalone = window?.navigator?.standalone;
        const isInstalled = window?.matchMedia('(display-mode: standalone)')?.matches;
        const isPWA = !!(isStandalone || isInstalled);
        
        return {
            platform,
            isMobile,
            isStandalone: isPWA,
            // Блокируем ТОЛЬКО мобильных пользователей, у которых не установлено PWA
            needsInstall: isMobile && !isPWA,
        };
    };

    // Показываем баннер для установки PWA
    const showInstallPrompt = () => {
        const pwaStatus = checkPWAStatus();
        
        if (pwaStatus.needsInstall) {
            // Показываем кнопку установки
            return {
                show: true,
                platform: pwaStatus?.platform,
                message: getInstallMessage(pwaStatus?.platform)
            };
        }
        
        return { show: false };
    };

    // Добавьте новую функцию для запроса разрешения
    const requestPushPermission = async () => {
        try {
            const platform = getPlatform();
            
            if (platform === 'ios') {
                return await handleIOSPush();
            } else {
                return await handleStandardPush();
            }
        } catch (error) {
            console.error('Ошибка запроса разрешения:', error);
            return { type: 'error', error };
        }
    };

    const handleIOSPush = async () => {
        const isStandalone = window?.navigator?.standalone || 
                            window?.matchMedia('(display-mode: standalone)')?.matches;
        
        if (!isStandalone) {
            // Показываем инструкцию по установке PWA
            return {
                type: 'ios_need_install',
                message: 'Для уведомлений на iOS установите приложение на домашний экран'
            };
        }
        
        // Если PWA установлено, запрашиваем разрешение
        if ('Notification' in window && Notification?.permission === 'default') {
            const permission = await Notification?.requestPermission();
            
            if (permission === 'granted') {
                return await subscribeForOtherPlatforms(tokenEmployee);
            }
        }
        
        return { type: 'ios_permission_denied' };
    };

    const handleStandardPush = async () => {
        if (!('Notification' in window)) {
            return { type: 'not_supported' };
        }
        
        const permission = await Notification?.requestPermission();
        
        if (permission === 'granted') {
            return await subscribeForOtherPlatforms(tokenEmployee);
        }
        
        return { type: 'permission_denied' };
    };

    const getInstallMessage = (platform) => {
        switch(platform) {
            case 'ios':
                return 'Для установки нажмите "Поделиться" → "На экран "Домой"';
            case 'android':
                return 'Для установки нажмите меню → "Установить приложение"';
            default:
                return 'Для установки нажмите кнопку "Установить" в адресной строке браузера';
        }
    };

    // В контексте добавляем состояние
    const [pwaStatus, setPwaStatus] = useState(() => {
        const status = checkPWAStatus();
        return {
            isInstalled: !status?.needsInstall,
            platform: status?.platform,
            isMobile: status?.isMobile,
            showInstallPrompt: status?.needsInstall,
            needsInstall: status?.needsInstall,
        };
    });

    // Эффект для проверки статуса PWA
    useEffect(() => {
        const status = checkPWAStatus();
        setPwaStatus({
            isInstalled: !status?.needsInstall,
            platform: status?.platform,
            isMobile: status?.isMobile,
            showInstallPrompt: status?.needsInstall,
            needsInstall: status?.needsInstall,  // ← добавить это поле
        });
        
        // Слушаем изменения режима отображения
        const mediaQuery = typeof window.matchMedia === 'function'
            ? window.matchMedia('(display-mode: standalone)') : null;
        const handleChange = () => {
            const newStatus = checkPWAStatus();
            setPwaStatus(prev => ({
                ...prev,
                isInstalled: !newStatus?.needsInstall,
                showInstallPrompt: newStatus?.needsInstall
            }));
        };
        
        return listenMediaQuery(mediaQuery, handleChange);
    }, []);

    const checkNotificationStatus = () => {
        if (typeof Notification === 'undefined' || !('Notification' in window)) {
            return null;
        }
        return Notification;
    };

    // Обновляем useEffect для подписки на push
    useEffect(() => {
        if (!tokenEmployee || pwaStatus?.showInstallPrompt) return;

        // Автоматически подписываем ТОЛЬКО если разрешение уже дано
        // и НЕ открываем модалку теста — это фоновое восстановление подписки
        if (typeof Notification !== 'undefined' && Notification?.permission === 'granted') {
            processPushSubscription(tokenEmployee);
        }
        // Если permission === 'default' или 'denied' — ждём действия пользователя
    }, [tokenEmployee, pwaStatus?.isInstalled]);




    // useEffect(() => {
    //     if (account && tokenEmployee) {
    //         getDeals();
    //     }

    //     // Установка повторного запроса каждую 1 час
    //     const interval = setInterval(() => {
    //         if (account && tokenEmployee) {
    //             getDeals();
    //             if (account?.id) {
    //                 if (account?.position == "draftsman") {
    //                     updateListEvents("drawing", account.id);
    //                 }
    //             }
    //         }
            
    //     }, 1000 * 1000); // 1 час в миллисекундах

    //     // Очистка интервала при размонтировании компонента
    //     return () => clearInterval(interval);
    // }, []);
    
    const values = {
        tokenEmployee, setTokenEmployee,
        sidebarOpen, setSidebarOpen,
        account, setAccount, accountLoaded,
        activeRole, setActiveRole: switchRole, switchRole, effectiveRole, availableCabinets,

        listEvents, setListEvents,
        citys, setCitys, getCitys,
        employee, setEmployee, getEmployeeList, employeeLoading,
        employeeAll, setEmployeeAll, getEmployeeAll,
        programs, setPrograms, getPrograms,

        uploadProcesses, addUploadProcess, removeUploadProcess,
        
        loadListEvents, setLoadListEvents,
        listPaymentEvents, setListPaymentEvents,
        getPaymentEvents,
        dateRange,
        setCurrentDateRange,
        updateListEvents, 
        modalEvent, setModalEvent,
        modalApplication, setModalApplication,
        modalQuest, setModalQuest,
        modalAddAdditionalService, setModalAddAdditionalService,
        modalPaymentBreakdown, setModalPaymentBreakdown,
        toasts, notify, dismissToast,
        modalConfirmDeleteFile, setModalConfirmDeleteFile,
        modalReviewEmployee, setModalReviewEmployee,
        modalProfile, setModalProfile,
        modalCompleteEvent, setCompleteModalEvent,
        modalKonsolConnect, setModalKonsolConnect,
        modalFailEvent, setFailModalEvent,
        modalSupplementEvent, setSupplementModalEvent,
        modalOverdueEvents, setModalOverdueEvents,
        newsStories, setNewsStories, loadNewsFeed,
        storiesBar, setStoriesBar, loadStoriesBar,
        chatModal, setChatModal,
        modalDispatchResponses, setModalDispatchResponses,
        modalTestPush, setModalTestPush,
        modalIOSNotifHelp, setModalIOSNotifHelp,
        
        files, setFiles,
        unreadCounts, setUnreadCounts, getChatUnread,

        centerNotifs, notifUnread, notifPanelOpen, setNotifPanelOpen,
        refreshNotifs, markNotifRead, markAllNotifsRead,

        getEmployee,

        chats, setChats,
        coverageOnboardingNeeded,
        setCoverageOnboardingNeeded,
        coverageOnboardingChecked,
        setCoverageOnboardingChecked,
        notificationWsConnected,
        notifications,
        loadsUnreadCounts,
        markAsRead,
        totalUnread,
        openNotif, setOpenNotif,
        modalEmployee, setModalEmployee,
        
        additionalServices, setAdditionalServices,
        modalAddEventService, setModalAddEventService,
        getAdditionalServices,
        
        dealList, setDealList,
        loadDealList, setLoadDealList,
        getDeals,

        lock, setLock,
        loadInitial, setLoadInitial,

        modalTicketSupport, 
        setModalTicketSupport,
        techSupportTickets,
        setTechSupportTickets,
        loadTechSupport,
        setLoadTechSupport,
        modalKnowledge, setModalKnowledge,
        
        checkNotificationStatus,
        modalNotification, setModalNotification,
        getPlatform,
        showInstallPrompt,
        subscribeUserToPush,
        requestPushPermission,
        pwaStatus,

        applicationsList, setApplicationsList,
        applicationsCounts,
        boardRefreshKey, bumpBoardRefresh,
        applicationsLoading, loadApplications,
        pendingPerformersCount, refreshPendingPerformers,
        unassignedAppsCount, refreshUnassignedCount,
        applicationsPanelOpen, setApplicationsPanelOpen, toggleApplicationsPanel,
        selectedApplicationId, setSelectedApplicationId, selectApplication,
    };
    
    const PUBLIC_PATHS = ["/privacy-policy"];
    const isPublicPath = PUBLIC_PATHS.some(p => location.pathname.startsWith(p));

    return (
        <LayoutContext.Provider value={values}>
            {isPublicPath ? (
                children
            ) : loadInitial ? (
                <VerificationScreen />
            ) : lock ? (
                <LockPage/>
            ) : pwaStatus?.needsInstall ? (
                <PWAInstallRequired platform={pwaStatus.platform} />
            ) : (
                <>
                    {children}
                    <ModalTechSupport />
                </>
            )}
        </LayoutContext.Provider>
    );
}



// Экран верификации
function VerificationScreen() {
    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#ffffff',
            zIndex: 100000,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}>
            <div style={{
                width: 48,
                height: 48,
                border: '4px solid #e4ddfb',
                borderTopColor: '#572AC3',
                borderRadius: '50%',
                animation: 'splash-spin 0.8s linear infinite',
            }}/>
            <div style={{
                marginTop: 16,
                color: '#572AC3',
                fontSize: 14,
                fontWeight: 500,
            }}>
                Идёт верификация...
            </div>
        </div>
    );
}


function PWAInstallRequired({ platform }) {
    const isIOS = platform === 'ios';

    return (
        <Box sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 999999,
            bgcolor: 'white',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: 3,
            textAlign: 'center',
            gap: 2,
        }}>
            <Box sx={{ fontSize: 64 }}>📲</Box>

            <Typography level="h3" sx={{ fontWeight: 700 }}>
                Установите приложение
            </Typography>

            <Typography level="body-md" sx={{ color: 'text.secondary', maxWidth: 320 }}>
                Для работы и получения уведомлений необходимо добавить сайт на рабочий стол как приложение.
            </Typography>

            <Box sx={{
                bgcolor: '#f5f5f5',
                borderRadius: 'lg',
                p: 2.5,
                width: '100%',
                maxWidth: 340,
                textAlign: 'left',
            }}>
                {isIOS ? (
                    <>
                        <Typography level="title-md" sx={{ mb: 1.5, fontWeight: 700 }}>
                            📱 Инструкция для iPhone / iPad
                        </Typography>
                        <Stack spacing={1.5}>
                            <Typography level="body-sm">1. Нажмите кнопку <b>«Поделиться»</b> внизу Safari (квадрат со стрелкой ↑)</Typography>
                            <Typography level="body-sm">2. Прокрутите список и нажмите <b>«На экран "Домой"»</b></Typography>
                            <Typography level="body-sm">3. Нажмите <b>«Добавить»</b> в правом верхнем углу</Typography>
                            <Typography level="body-sm">4. Откройте приложение с рабочего стола 🎉</Typography>
                        </Stack>
                    </>
                ) : (
                    <>
                        <Typography level="title-md" sx={{ mb: 1.5, fontWeight: 700 }}>
                            🤖 Инструкция для Android
                        </Typography>
                        <Stack spacing={1.5}>
                            <Typography level="body-sm">1. Нажмите <b>меню (⋮)</b> в правом верхнем углу Chrome</Typography>
                            <Typography level="body-sm">2. Нажмите <b>«Установить приложение»</b> или <b>«Добавить на главный экран»</b></Typography>
                            <Typography level="body-sm">3. Подтвердите и откройте приложение с рабочего стола 🎉</Typography>
                        </Stack>
                    </>
                )}
            </Box>

            <Typography level="body-xs" sx={{ color: 'text.tertiary', maxWidth: 300 }}>
                После установки Push-уведомления будут работать автоматически
            </Typography>
        </Box>
    );
}
